/* src/app/company-setting/company-setting-feature/company-setting-feature.component.scss */
body#themeTag :host ::ng-deep {
  line-height: 1.5rem !important;
}
/*# sourceMappingURL=company-setting-feature.component.css.map */
